import React from 'react';
import { Briefcase, Zap, Globe } from 'lucide-react';

export default function JobListingsHeader() {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Briefcase size={22} className="text-primary" />
          <h1 className="text-2xl font-700 text-foreground">Driver Job Listings</h1>
        </div>
        <p className="text-sm text-muted-foreground">
          All vacancies DriveSA monitors and auto-applies to on your behalf — updated daily.
        </p>
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-xl px-4 py-2.5">
          <Zap size={15} className="text-green-600" />
          <div>
            <p className="text-xs font-700 text-green-700">Auto-Apply Active</p>
            <p className="text-[10px] text-green-600">Applying to all matching jobs</p>
          </div>
        </div>
        <div className="flex items-center gap-2 bg-blue-50 border border-blue-200 rounded-xl px-4 py-2.5">
          <Globe size={15} className="text-blue-600" />
          <div>
            <p className="text-xs font-700 text-blue-700">1,240 Active Jobs</p>
            <p className="text-[10px] text-blue-600">SA & International</p>
          </div>
        </div>
      </div>
    </div>
  );
}